import React, { useState } from "react";
import { toast } from "react-toastify";
import apiServices from "../../services/service";
import FormModalWrapper from "../../shared/modal/FormModalWrapper";
import SearchableDropDown from "../../shared/controls/form/searchableDropdown";

const ACCESS_LEVEL_OPTIONS = [
  { value: "L1", label: "L1" },
  { value: "L2", label: "L2" },
  { value: "L3", label: "L3" },
];

const AddBucketForm = ({ open, onClose, onSave, usersList = [] }) => {
  const [bucketName, setBucketName] = useState("");
  const [owner, setOwner] = useState(null);
  const [accessLevel, setAccessLevel] = useState(null);
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);

  const userOptions = usersList.map((u) => ({
    value: u.userId,
    label:
      `${u.firstName || ""} ${u.lastName || ""}`.trim() ||
      u.userName ||
      u.emailAddress ||
      u.email ||
      "",
  }));

  const reset = () => {
    setBucketName("");
    setOwner(null);
    setAccessLevel(null);
    setErrors({});
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  const handleSave = () => {
    const newErrors = {};
    if (!bucketName.trim()) newErrors.bucketName = "Bucket name is required";
    if (!owner) newErrors.owner = "Bucket owner is required";
    if (!accessLevel) newErrors.accessLevel = "Access level is required";
    if (Object.keys(newErrors).length) {
      setErrors(newErrors);
      return;
    }

    const payload = {
      name: bucketName.trim(),
      bucketOwnerId: owner?.value ?? null,
      accessLevel: accessLevel?.value ?? null,
    };

    setSaving(true);
    apiServices
      .addBucket(payload)
      .then((response) => {
        toast.success("Bucket added successfully!", { position: "top-right" });
        onSave(response.data);
        reset();
      })
      .catch((error) => {
        toast.error(
          error?.response?.data?.message || error.message || "Failed to add bucket",
          { position: "top-right" }
        );
      })
      .finally(() => setSaving(false));
  };

  return (
    <FormModalWrapper
      open={open}
      onClose={handleClose}
      breadcrumb="Bucket Management"
      title="Add Bucket"
      size="sm"
      onSave={handleSave}
      saveDisabled={saving}
    >
      <div className="row">
        <div className="col-12">
          <div className="input-container">
            <label htmlFor="bucketName">
              Bucket Name <span className="required-star">*</span>
            </label>
            <input
              id="bucketName"
              className="formik-input"
              type="text"
              value={bucketName}
              onChange={(e) => {
                setBucketName(e.target.value);
                if (errors.bucketName) setErrors((prev) => ({ ...prev, bucketName: undefined }));
              }}
              placeholder="Enter bucket name"
            />
            {errors.bucketName && (
              <div className="error-message">{errors.bucketName}</div>
            )}
          </div>
        </div>

        <div className="col-12">
          <div className="input-container">
            <SearchableDropDown
              label="Bucket Owner"
              name="owner"
              fieldName="owner"
              value={owner}
              placeholder="Select owner"
              options={userOptions}
              isRequired
              error={!!errors.owner}
              errormsg={errors.owner}
              onChange={(selected) => {
                setOwner(selected);
                if (errors.owner) setErrors((prev) => ({ ...prev, owner: undefined }));
              }}
            />
          </div>
        </div>

        <div className="col-12">
          <div className="input-container">
            <SearchableDropDown
              label="Access Level"
              name="accessLevel"
              fieldName="accessLevel"
              value={accessLevel}
              placeholder="Select access level"
              options={ACCESS_LEVEL_OPTIONS}
              isRequired
              error={!!errors.accessLevel}
              errormsg={errors.accessLevel}
              onChange={(selected) => {
                setAccessLevel(selected);
                if (errors.accessLevel) setErrors((prev) => ({ ...prev, accessLevel: undefined }));
              }}
            />
          </div>
        </div>
      </div>
    </FormModalWrapper>
  );
};

export default AddBucketForm;
